import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
interface FeaturedBrandsCarouselProps {
  brands: Array<{
    id: number;
    name: string;
    logo: string;
    discount: number;
    description: string;
  }>;
}
export function FeaturedBrandsCarousel({
  brands
}: FeaturedBrandsCarouselProps) {
  const [cardsPerView, setCardsPerView] = useState(4);
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCardsPerView(1);
      } else if (window.innerWidth < 1024) {
        setCardsPerView(3);
      } else {
        setCardsPerView(4);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % Math.max(1, brands.length - cardsPerView + 1));
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + Math.max(1, brands.length - cardsPerView + 1)) % Math.max(1, brands.length - cardsPerView + 1));
  };
  return <>
      <div className="bg-gradient-to-r from-[#1E2B55] to-[#162041] rounded-xl p-6 text-white" data-id="element-2022" data-mp="19dmelsirvj8z">
        <div className="flex items-center justify-between mb-6" data-id="element-2023" data-mp="1ed8s832ij1ib">
          <div className="flex items-center gap-3" data-id="element-2024" data-mp="1j48pj9fjnllc">
            <div className="bg-yellow-400 p-2 rounded-full" data-id="element-2025" data-mp="1j50n2pspbte9">
              <SparklesIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-2026" data-mp="1n6c446xif6au" />
            </div>
            <div data-id="element-2027" data-mp="1s4x5wasety1e">
              <h2 className="text-2xl font-bold" data-id="element-2028" data-mp="1s4dxplskao0k">Featured Brands</h2>
              <p className="text-white text-opacity-80" data-id="element-2029" data-mp="1s6qdptereoaz">
                Exclusive deals from top brands
              </p>
            </div>
          </div>
          <div className="flex gap-2" data-id="element-2030" data-mp="2221qw7airngm">
            <button onClick={prevSlide} className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg transition-all" data-id="element-2031" data-mp="220qr0ik72zus">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-2032" data-mp="7pva8syuwegx" />
            </button>
            <button onClick={nextSlide} className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg transition-all" data-id="element-2033" data-mp="3vsyvdsmmeee1">
              <ChevronRightIcon className="w-6 h-6" data-id="element-2034" data-mp="9mk3sb92tx9n" />
            </button>
          </div>
        </div>

        <div className="relative overflow-hidden" data-id="element-2035" data-mp="4ngyqqt3jr1o">
          <div className="flex transition-transform duration-500 ease-out" style={{
          transform: `translateX(-${currentIndex * (100 / cardsPerView)}%)`
        }} data-id="element-2036" data-mp="4mnwa2167npc">
            {brands.map((brand, index) => <div key={brand.id} className="flex-shrink-0 w-full md:w-1/3 lg:w-1/4 px-2" data-id="element-2037" data-mp="sdl1kvygnmrm" data-mpi={index}>
                <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 h-full border border-white/10" data-id="element-2038" data-mp="negucav3jz3x">
                  <div className="bg-white rounded-lg p-4 mb-4 h-24 flex items-center justify-center" data-id="element-2039" data-mp="11bnaryscllpz">
                    <img src={brand.logo} alt={brand.name} className="max-w-full max-h-full object-contain" data-id="element-2040" data-mp="xa1s1wt4ud7v" />
                  </div>
                  <h3 className="font-bold text-lg mb-1" data-id="element-2041" data-mp="16zqpdytno7sf">{brand.name}</h3>
                  <p className="text-sm text-white text-opacity-80 mb-3" data-id="element-2042" data-mp="171us4dftj0r4">
                    {brand.description}
                  </p>
                  <div className="bg-yellow-400 text-[#1E2B55] font-bold text-center py-2 rounded-lg" data-id="element-2043" data-mp="x9fc3lo30m8v">
                    Up to {brand.discount}% OFF
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </>;
}